import run from '../../utilities/run';
import $ from 'jquery';

run("#oauth-redirect-page", ()=> {
  const oAuthRedirectPage = $("#oauth-redirect-page");
  const success = oAuthRedirectPage.data("success");

  localStorage.setItem("connectionStatus", success);
});



// WEBPACK FOOTER //
// ./src/pages/oAuth/oAuthRedirectPage.js